import { Component, Inject, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StepTypes } from '../../../model/enums/step-types';
import { UDeuStep } from '../../../model/classes/udeu-step';
import { MatFormFieldType } from '../../../model/enums/mat-form-field-types';
import { UdeuService } from '../../../services/udeu.service';
import { Store } from '@ngrx/store';
import { AppStore, getUserProfile, SnackbarErrorAction } from '@alfresco/aca-shared/store';
import { Router } from '@angular/router';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';
import { LoanActionTypes } from '../../../store/actions/loan-actions';
import { UdeuData, UdeuInfo, UdeuLoan } from '../../../model/classes/udeu-loan';
import { LoanService } from '../../../services/loan.service';
import { ARCHIVIST_FIELD, CENTER_FIELD, CREATED_FIELD, DESCRIPTION_FIELD, EMAIL_FIELD, END_DATE_FIELD, EXTERNAL_FIELD, INFO_STEP, INTER_DEP_FIELD, INTERNAL_NOTES_FIELD, LAST_YEAR_ENROLLMENT_FIELD, MAIN_DATA_STEP, METHOD_FIELD, NAME_FIELD, OBSERVATIONS_FIELD, REASON_FIELD, REGISTERS_FIELD, REGISTERS_STEP, RENEW_DATE_FIELD, RENEW_OBSERVATIONS_FIELD, RETURN_DATE_FIELD, START_DATE_FIELD, STUDENT_FIELD } from '../../../model/contants/udeu-loan';
import { DateType } from 'projects/alden-extension/src/lib/models/date-types';
import { UdeuStatus } from '../../../model/classes/udeu-status';
import { GROUP_LOANS_SITE_MANAGER, UDEU_LOAN_BORROWED_STATUS, UDEU_LOAN_FINISHED_STATUS, UDEU_LOAN_IN_PROGRESS_STATUS, UDEU_LOAN_REJECTED_STATUS, UDEU_LOAN_REQUESTED_STATUS, UDEU_LOAN_RETURNED_STATUS } from '../../../model/contants/deusto';
import { KeyValue } from '@angular/common';
import { isInGroup } from 'projects/alden-extension/src/lib/rules/alden.rules';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProfileState } from '@alfresco/adf-extensions';
import { ArrayValidators } from 'projects/alden-extension/src/lib/validators/array.validator';
import { UdeuRecord } from '../../../model/classes/udeu-record';
import { MatStep } from '@angular/material/stepper';
import { Empleado } from '../../../model/classes/gaude-empleado';
import { SMTLoadingDialogComponent } from 'projects/alden-extension/src/lib/dialogs/loading/loading.dialog';
import { METHOD_DATALIST_NAME } from '../../../model/contants/datalists';

export interface DialogData {
  UUID: string;
  loanActionType: LoanActionTypes;
  openedByUrl?: boolean;
}

@Component({
  templateUrl: './create-loan.dialog.html',
  styleUrls: ['./create-loan.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateLoanDialogComponent implements OnInit {
  loading: boolean;

  private _formBuilder = inject(FormBuilder);
  steps: { [id: string]: UDeuStep };

  mainFormGroup: FormGroup<any>;
  dataFormGroup: FormGroup<any>;
  infoFormGroup: FormGroup<any>;
  registersFormGroup: FormGroup<any>;

  StepTypes: typeof StepTypes = StepTypes;
  MatFormFieldType: typeof MatFormFieldType = MatFormFieldType;
  LoanActionTypes: typeof LoanActionTypes = LoanActionTypes;
  DateType: typeof DateType = DateType;

  udeuLoan: UdeuLoan;

  UDEU_LOAN_REJECTED_STATUS = UDEU_LOAN_REJECTED_STATUS;
  UDEU_LOAN_ACCEPTED_STATUS = UDEU_LOAN_IN_PROGRESS_STATUS;
  UDEU_LOAN_RETURNED_STATUS = UDEU_LOAN_RETURNED_STATUS;
  UDEU_LOAN_FINISHED_STATUS = UDEU_LOAN_FINISHED_STATUS;

  profile$: Observable<ProfileState>;
  isManager: boolean;
  
  selectedIndex: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<CreateLoanDialogComponent>, private dialog: MatDialog, 
    public udeuService: UdeuService, private loanService: LoanService, protected store: Store<AppStore>, private router: Router) {
      this.profile$ = this.store.select(getUserProfile);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.beforeClosed();
              
    this.profile$.pipe(take(1)).subscribe(async (profile) => {
      this.isManager = isInGroup(profile, GROUP_LOANS_SITE_MANAGER);

      await this.initilizeForms();
      this.createSteps();
       
      if(this.data?.loanActionType !== LoanActionTypes.ViewLoan)
        await this.udeuService.getMasterList(this.steps, INFO_STEP, METHOD_FIELD, METHOD_DATALIST_NAME);

      if(this.data?.loanActionType === LoanActionTypes.ValidateRenewLoan) {
        this.selectedIndex = 1;
      }

      this.loading = false;
    });
  }

  checkOpenEditionByUrl() {
    if(this.data?.openedByUrl) {
      const status = this.udeuLoan?.status?.status as KeyValue<string, string>;
      if(this.isManager) {
        switch (status.key) {
          case UDEU_LOAN_REQUESTED_STATUS:
            this.data.loanActionType = LoanActionTypes.ValidateLoan;
            break;
          case UDEU_LOAN_IN_PROGRESS_STATUS:
            this.data.loanActionType = LoanActionTypes.GrantLoan;
            this.selectedIndex = 2;
            break;
          case UDEU_LOAN_BORROWED_STATUS:
            this.data.loanActionType = this.udeuLoan?.info?.renewDate ? LoanActionTypes.ValidateRenewLoan : LoanActionTypes.ReturnLoan;
            this.selectedIndex = 1;
            break;
          default:
            this.data.loanActionType = LoanActionTypes.ViewLoan;
            this.mainFormGroup.disable();
            break;
        }
      } else {
        this.data.loanActionType = LoanActionTypes.ViewLoan;
        this.mainFormGroup.disable();
      }
    }
  }

  beforeClosed() {
    // Interceptamos el evento de cerrar el diálogo
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });

    // Interceptamos el evento de presionar la tecla Esc
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    if(this.data?.loanActionType === LoanActionTypes.ViewLoan) {
      this.dialogRef.close();
      return;
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: {
        title: 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CLOSE.DIALOG.TITLE',
        message: 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CLOSE.DIALOG.MESSAGE',
        noLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CLOSE.DIALOG.NO_LABEL',
        yesLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CLOSE.DIALOG.YES_LABEL'
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {       
        this.dialogRef.close();
      }
    });
  }

  async initilizeForms() {
    const UUID = this.data?.UUID;
    if(UUID) {
      await this.loanService.getLoan(UUID).then((res) => { 
        this.udeuLoan = res;
      });
    } else {
      await this.udeuService.getEmployeeData().then((res: KeyValue<string, Empleado>) => { 
        if(res) {
          this.udeuLoan = new UdeuLoan();
          const data = new UdeuData();
          data.email = res.key;
          data.applicantName = res.value?.nombre;
          this.udeuLoan.data = data;
        }
      }).catch((err) => { 
        console.error("ERROR", err);
        this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
        this.dialogRef.close();
      });
    }

    this.dataFormGroup = this._formBuilder.group({
      [NAME_FIELD]: [this.udeuLoan?.data?.applicantName, [Validators.required]],
      [EMAIL_FIELD]: [this.udeuLoan?.data?.email, [Validators.required, Validators.email]],
      [CREATED_FIELD]: [this.udeuLoan?.data?.requestDate ?? (this.isManager ? new Date() : null)],
      [REASON_FIELD]: [this.udeuLoan?.data?.reason, [Validators.required]],
      [LAST_YEAR_ENROLLMENT_FIELD]: [this.udeuLoan?.data?.lastYearEnrollment],
      [STUDENT_FIELD]: [this.udeuLoan?.data?.student],
      [DESCRIPTION_FIELD]: [this.udeuLoan?.data?.description, [Validators.required]],
      [EXTERNAL_FIELD]: [!this.udeuLoan?.id ? (this.isManager ? true : false) : this.udeuLoan?.data?.external],
      [INTER_DEP_FIELD]: [{ value: this.udeuLoan?.data?.interdepartmental, disabled: true }]
    });

    this.infoFormGroup = this._formBuilder.group({
      [ARCHIVIST_FIELD]: [{ value: this.udeuLoan?.info?.archivist, disabled: true }],
      [CENTER_FIELD]: [{ value: this.udeuLoan?.info?.center, disabled: true }],
      [START_DATE_FIELD]: [{ value: this.udeuLoan?.info?.startDate, disabled: true }],
      [END_DATE_FIELD]: [{ value: this.udeuLoan?.info?.endDate, disabled: true }],
      [RETURN_DATE_FIELD]: [this.udeuLoan?.info?.returnDate, [Validators.required]],
      [METHOD_FIELD]: [this.udeuLoan?.info?.method, this.data.loanActionType === LoanActionTypes.GrantLoan ? [Validators.required] : null],
      [RENEW_DATE_FIELD]: [{ value: this.udeuLoan?.info?.renewDate, disabled: true }],
      [RENEW_OBSERVATIONS_FIELD]: [{ value: this.udeuLoan?.info?.renewObservations, disabled: true }],
      [OBSERVATIONS_FIELD]: [this.udeuLoan?.info?.observations],
      [INTERNAL_NOTES_FIELD]: [this.udeuLoan?.info?.internalNotes],
    });

    this.registersFormGroup = this._formBuilder.group({
      [REGISTERS_FIELD]: this._formBuilder.array([], ArrayValidators.required)
    });

    this.mainFormGroup = this._formBuilder.group({
      data: this.dataFormGroup,
      info: this.infoFormGroup,
      registers: this.registersFormGroup
    });

    this.checkOpenEditionByUrl();

    if(!this.isManager) {
      if(!UUID && this.dataFormGroup.get(NAME_FIELD).value)
        this.dataFormGroup.get(NAME_FIELD).disable();
      if(!UUID && this.dataFormGroup.get(EMAIL_FIELD).value)
        this.dataFormGroup.get(EMAIL_FIELD).disable();
    }

    if(!this.data?.loanActionType || this.data.loanActionType === LoanActionTypes.CreateLoan) {
      this.infoFormGroup.disable();
      this.registersFormGroup.disable();
    } else if(this.data.loanActionType === LoanActionTypes.EditLoan) {
      if(!this.isManager){
        this.mainFormGroup.disable();
        this.dataFormGroup.get(EXTERNAL_FIELD).enable();
        if( this.udeuLoan.info.returnDate && (this.udeuLoan?.status.status === UDEU_LOAN_BORROWED_STATUS || (this.udeuLoan?.status.status as KeyValue<string,string>).key === UDEU_LOAN_BORROWED_STATUS)){
          this.infoFormGroup.get(RETURN_DATE_FIELD).enable();
          this.dataFormGroup.get(REASON_FIELD).enable();
        }
        this.infoFormGroup.get(OBSERVATIONS_FIELD).enable();
        this.infoFormGroup.get(INTERNAL_NOTES_FIELD).enable();
      }else
        this.mainFormGroup.enable();
    } else if(this.data.loanActionType === LoanActionTypes.ViewLoan 
      || this.data.loanActionType === LoanActionTypes.ValidateLoan 
      || this.data.loanActionType === LoanActionTypes.ReturnLoan
      || this.data.loanActionType === LoanActionTypes.FinishLoan) {
      this.mainFormGroup.disable();
    } else if(this.data.loanActionType === LoanActionTypes.ValidateRenewLoan) {
      this.mainFormGroup.disable();
    }

    if(this.data?.loanActionType === LoanActionTypes.GrantLoan) {
      this.dataFormGroup.disable();
      const returnDate = this.infoFormGroup.get(RETURN_DATE_FIELD);
      if(!returnDate.value) {
        const today = new Date();
        const date = new Date(today);
        date.setDate(today.getDate() + 15);
        returnDate.setValue(date);
      }
    }
  }

  createSteps() {
    this.steps = {
      [MAIN_DATA_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.MAIN_DATA.TITLE",
        type: StepTypes.GENERIC,
        form: {
          group: this.dataFormGroup,
          fields: {
            [NAME_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.NAME"
            },
            [EMAIL_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.EMAIL"
            },
            [CREATED_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.CREATED",
              disabled: (!this.isManager && !this.udeuLoan?.data?.requestDate),
            },
            [REASON_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.REASON",
              style: (!this.isManager && !this.udeuLoan?.data?.requestDate) ? { width: '100%' } : null
            },
            [LAST_YEAR_ENROLLMENT_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.LAST_YEAR_ENROLLMENT"
            },
            [STUDENT_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.STUDENT"
            },
            [DESCRIPTION_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.DESCRIPTION",
              style: { width: '100%' }
            },
            [EXTERNAL_FIELD]: {
              type: MatFormFieldType.BOOLEAN,
              disabled: !this.isManager,
              placeholder: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.EXTERNAL",
              extraPlaceholder: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.NOT_EXTERNAL",
            },
            [INTER_DEP_FIELD]: {
              type: MatFormFieldType.BOOLEAN, 
              disabled: !this.isManager || this.data?.loanActionType === LoanActionTypes.CreateLoan,
              placeholder: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.INTER_DEP",
              extraPlaceholder: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.NOT_INTER_DEP"
            },
          }
        }
      },
      [INFO_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.INFO.TITLE",
        type: StepTypes.GENERIC,
        disabled: !this.udeuLoan?.status 
                  || (this.udeuLoan.status.status as KeyValue<string, string>).key === UDEU_LOAN_REQUESTED_STATUS 
                  || (this.udeuLoan.status.status as KeyValue<string, string>).key === UDEU_LOAN_REJECTED_STATUS,
        form: {
          group: this.infoFormGroup,
          fields: {
            [ARCHIVIST_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.ARCHIVIST",
              disabled: !this.isManager || !this.udeuLoan?.info?.archivist,
              style: !this.udeuLoan?.info?.center ? { width: '100%' } : null
            },
            [CENTER_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.CENTER",
              disabled: !this.isManager || !this.udeuLoan?.info?.center
            },
            [START_DATE_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.START_DATE",
              disabled: !this.udeuLoan?.info?.startDate,
              style: !this.udeuLoan?.info?.endDate ? { width: '100%' } : null
            },
            [END_DATE_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.END_DATE",
              disabled: !this.udeuLoan?.info?.endDate,
              style: !this.udeuLoan?.info?.startDate ? { width: '100%' } : null
            },
            [RETURN_DATE_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RETURN_DATE",
              style: { width: '100%' }
            },
            [RENEW_DATE_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RENEW_DATE",
              disabled: !this.udeuLoan?.info?.renewDate,
              style: !this.udeuLoan?.info?.renewObservations ? { width: '100%' } : null
            },
            [RENEW_OBSERVATIONS_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.RENEW_OBSERVATIONS",
              disabled: !this.udeuLoan?.info?.renewObservations,
            },
            [OBSERVATIONS_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.OBSERVATIONS",
              style: { width: '100%' }
            },
            [INTERNAL_NOTES_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.INFO.INTERNAL_NOTES",
              style: { width: '100%' },
              disabled: !this.isManager
            },
             [METHOD_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.METHOD",
              style: { width: '100%' },
              disabled: !this.isManager || this.data?.loanActionType !== LoanActionTypes.GrantLoan,
            },
          }
        }
      },
      [REGISTERS_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.TITLE",
        type: StepTypes.LENTS,
        disabled: !this.udeuLoan?.status 
                  || (this.udeuLoan.status.status as KeyValue<string, string>).key === UDEU_LOAN_REQUESTED_STATUS 
                  || (this.udeuLoan.status.status as KeyValue<string, string>).key === UDEU_LOAN_REJECTED_STATUS
                  || ((this.udeuLoan.status.status as KeyValue<string, string>).key === UDEU_LOAN_IN_PROGRESS_STATUS && !this.isManager),
        form: {
          group: this.registersFormGroup,
        }
      }
    }
  }

  createLoan(save: boolean = false) {
    let status;

    // Crear nuevo Prestamo
    let title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CREATE.DIALOG.TITLE';
    let message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CREATE.DIALOG.MESSAGE';
    let noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CREATE.DIALOG.NO_LABEL';
    let yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.CREATE.DIALOG.YES_LABEL';

    if(this.data?.loanActionType === LoanActionTypes.GrantLoan || this.data?.loanActionType === LoanActionTypes.EditLoan) {
      if(!save) {
        status = new UdeuStatus(UDEU_LOAN_BORROWED_STATUS);

        // Conceder Prestamo
        title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.GRANT.DIALOG.TITLE';
        message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.GRANT.DIALOG.MESSAGE';
        noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.GRANT.DIALOG.NO_LABEL';
        yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.GRANT.DIALOG.YES_LABEL';
      } else {
        status = new UdeuStatus((this.udeuLoan.status.status as KeyValue<string, string>).key);

        // Guardar Prestamo
        title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.EDIT.DIALOG.TITLE';
        message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.EDIT.DIALOG.MESSAGE';
        noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.EDIT.DIALOG.NO_LABEL';
        yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.EDIT.DIALOG.YES_LABEL';
      }
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title, 
        message, 
        noLabel, 
        yesLabel 
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {   
        const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
          data: {
            title: 'Cargando...',
          },
          minWidth: '250px'
        });

        const udeuLoan = new UdeuLoan();
        udeuLoan.status = status;
        udeuLoan.data = this.createData();
        udeuLoan.info = this.createInfo();
        udeuLoan.lentRecords = this.createRegisters();
        if(status?.status === UDEU_LOAN_BORROWED_STATUS &&  udeuLoan.lentRecords.length <= 0){
          this.dialogRef.close();
          loadingRef.close();
        }else{
            const promise = this.data?.loanActionType === LoanActionTypes.GrantLoan || this.data?.loanActionType === LoanActionTypes.EditLoan 
            ? this.loanService.updateLoan(this.data.UUID, udeuLoan) 
            : this.loanService.createLoan(udeuLoan);
            promise.then(() => {
              this.dialogRef.close();
              const route = '/viewer/loans';
              this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
            }).catch((err) => {
              console.error("ERROR", err);
              this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
            }).finally(() => {
              loadingRef.close();
            });
        }
      }
    });
  }

  changeStatusLoan(status: string) {
    // Aceptar transferencia
    let title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.ACCEPT.DIALOG.TITLE';
    let message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.ACCEPT.DIALOG.MESSAGE';
    let noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.ACCEPT.DIALOG.NO_LABEL';
    let yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.ACCEPT.DIALOG.YES_LABEL';
    let formField = false;

    if(UDEU_LOAN_REJECTED_STATUS === status) {
      // Rechazar transferencia
      title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.REJECT.DIALOG.TITLE';
      message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.REJECT.DIALOG.MESSAGE';
      noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.REJECT.DIALOG.NO_LABEL';
      yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.REJECT.DIALOG.YES_LABEL';
      formField = true;
    } else if(UDEU_LOAN_RETURNED_STATUS === status) {
      // Rechazar transferencia
      title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.RETURN.DIALOG.TITLE';
      message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.RETURN.DIALOG.MESSAGE';
      noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.RETURN.DIALOG.NO_LABEL';
      yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.RETURN.DIALOG.YES_LABEL';
    }else if(UDEU_LOAN_FINISHED_STATUS === status){
      // Finalizar transferencia
      title = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.FINISH.DIALOG.TITLE';
      message = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.FINISH.DIALOG.MESSAGE';
      noLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.FINISH.DIALOG.NO_LABEL';
      yesLabel = 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.ACTIONS.FINISH.DIALOG.YES_LABEL';
      formField = true;
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title,
        message, 
        noLabel, 
        yesLabel,
        formField,
      },
      minWidth: '250px'
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== false) {
        const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
          data: {
            title: 'Cargando...',
          },
          minWidth: '250px'
        });
                    
        const udeuStatus = new UdeuStatus(status, result !== true ? result : '');
        this.udeuService.updateStatus(this.data.UUID, udeuStatus).then(() => {
          this.dialogRef.close();
          const route = '/viewer/loans';
          this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
        }).catch((err) => {
          console.error("ERROR", err);
          this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
        }).finally(() => {
          loadingRef.close();
        });
      }
    });
  }

  createData(): UdeuData {
    const data = new UdeuData();
    data.applicantName = this.dataFormGroup.get(NAME_FIELD).value;
    data.email = this.dataFormGroup.get(EMAIL_FIELD).value;
    data.requestDate = this.dataFormGroup.get(CREATED_FIELD).value;
    data.description = this.dataFormGroup.get(DESCRIPTION_FIELD).value;
    data.reason = this.dataFormGroup.get(REASON_FIELD).value;
    data.lastYearEnrollment = this.dataFormGroup.get(LAST_YEAR_ENROLLMENT_FIELD).value;
    data.student = this.dataFormGroup.get(STUDENT_FIELD).value;
    data.external = this.dataFormGroup.get(EXTERNAL_FIELD).value;
    data.interdepartmental = this.dataFormGroup.get(INTER_DEP_FIELD).value;
    return data;
  }

  createInfo(): UdeuInfo {
    const info = new UdeuInfo();
    info.renewDate = this.infoFormGroup.get(RENEW_DATE_FIELD).value;
    info.returnDate = this.infoFormGroup.get(RETURN_DATE_FIELD).value;
    info.observations = this.infoFormGroup.get(OBSERVATIONS_FIELD).value;
    info.internalNotes = this.infoFormGroup.get(INTERNAL_NOTES_FIELD).value;
    info.method = (this.infoFormGroup.get(METHOD_FIELD).value as KeyValue<string,string>)?.key;

    return info;
  }

  createRegisters(): string[] {
    const value = (this.registersFormGroup.get(REGISTERS_FIELD).getRawValue() as UdeuRecord[]);
    return value?.length > 0 ? value.map((reg) => reg.id) : [];
  }

  isCompleted(matStep: MatStep) {
    const loanActionType = this.data?.loanActionType ?? LoanActionTypes.CreateLoan;
    switch (loanActionType) {
      case LoanActionTypes.CreateLoan:
        return !matStep.stepControl.invalid && matStep.interacted;

      case LoanActionTypes.GrantLoan:
        return !matStep.stepControl.invalid;
    
      default:
        return false;
    }
  }

  openRenew(reject: boolean = false) {
    const dialogRef = this.loanService.openLoanRenewDialogComponent(this.data.UUID, true, reject);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {   
        this.dialogRef.close();
      }
  });
  }

}
